export const PageOrientation = {
    Landscape: 'landscape',
    Portrait: 'portrait'
};
